// extracted by mini-css-extract-plugin
module.exports = {"categoriesCell":"categoriesCell__nMdkr","split":"split__Gu3XR","mode":"mode__GnJiR"};